import { ProductStatus, ProductType } from '../enums';

export interface Product {
  id: string;
  creatorId: string;
  title: string;
  description: string | null;
  price: number;
  type: ProductType;
  status: ProductStatus;
  createdAt: Date;
  updatedAt: Date;
}
